import * as React from 'react';
import { SVGProps } from 'react';

const ThirdPodiumIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const { width, height, ...restProps } = props;
  const gradientA = 'thirdPodiumGradientA';
  const gradientB = 'thirdPodiumGradientB';
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 282 218"
      width={width}
      height={height}
      fill="none"
    >
      <path fill={`url(#${gradientA})`} d="M0 32.629h281.63v184.444H0z" />
      <path
        fill={`url(#${gradientB})`}
        d="M31.683 0H248.48l33.15 33.227H0L31.683 0Z"
      />
      <defs>
        <linearGradient
          id={gradientA}
          x1={140.815}
          x2={140.815}
          y1={32.629}
          y2={217.073}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.125} stopColor="#FFD495" />
          <stop offset={1} stopColor="#FF9800" />
        </linearGradient>
        <linearGradient
          id={gradientB}
          x1={140.522}
          x2={140.522}
          y1={-9.041}
          y2={45.659}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.125} stopColor="#FFD495" />
          <stop offset={0.86} stopColor="#FF9800" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default ThirdPodiumIcon;
